import React from 'react';
export function FormPageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15381" data-mp="2es8f2u054jre">
      <span className="sr-only" data-id="element-15382" data-mp="14rugfsjbf3ue">Loading form…</span>
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-15383" data-mp="14smbn2902zk5">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-15384" data-mp="19r76sn9eat1q" />
        <div className="flex gap-2" data-id="element-15385" data-mp="19sqjk3vuelyr">
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15386" data-mp="c3ypl4gfg65j" />
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15387" data-mp="c5i5gty68f6s" />
        </div>
      </div>
      {/* Form card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15388" data-mp="m1cv490tbaj2">
        <div className="space-y-6" data-id="element-15389" data-mp="m3fsje4ao5xt">
          {/* Form sections */}
          {[1, 2].map(section => <div key={section} className="space-y-4" data-id="element-15390" data-mp="q0lkz2sqeo9c">
              <div className="h-5 w-32 bg-gray-200 rounded mb-4" data-id="element-15391" data-mp="1xfgmr8jxgmky" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15392" data-mp="21htqxsj10cfm">
                {[1, 2, 3, 4].map(i => <div key={i} data-id="element-15393" data-mp="1p6skf92ns57l">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15394" data-mp="1p60ofx55g5gs" />
                    <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-15395" data-mp="1k763aojpm4ti" />
                  </div>)}
              </div>
            </div>)}
          {/* Text area */}
          <div data-id="element-15396" data-mp="1b7j3g76mp72k">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15397" data-mp="1b5pyqxfkswx7" />
            <div className="h-32 w-full bg-gray-200 rounded-md" data-id="element-15398" data-mp="167enci9muecv" />
          </div>
          {/* Action buttons */}
          <div className="flex justify-end gap-2 pt-4 border-t border-gray-200" data-id="element-15399" data-mp="11gogt1ph05gl">
            <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15400" data-mp="whlmab749hmv" />
            <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-15401" data-mp="wi4wf5qiz1qc" />
          </div>
        </div>
      </div>
    </div>;
}